export const videoNodeName = 'video';

export enum VideoAttr {
    Service = 'service',
    VideoID = 'videoid',
}
